import i18next from "i18next"
import uk from "./uk.json"
import vi from "./vi.json"

i18next.init({
  interpolation: { escapeValue: false },
  lng: "vi",
  resources: {
    vi: {
      translation: vi,
    },
    uk: {
      translation: uk,
    },
  },
})

const t = (key: string, options?: any) => i18next.t(key, JSON.stringify(options)).toString()
export { t }
